import { render, staticRenderFns } from "./ProviderIntegrations.vue?vue&type=template&id=7b40d0b8&scoped=true&"
import script from "./ProviderIntegrations.vue?vue&type=script&lang=js&"
export * from "./ProviderIntegrations.vue?vue&type=script&lang=js&"
import style0 from "./ProviderIntegrations.vue?vue&type=style&index=0&id=7b40d0b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b40d0b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/monbi/bbx/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b40d0b8')) {
      api.createRecord('7b40d0b8', component.options)
    } else {
      api.reload('7b40d0b8', component.options)
    }
    module.hot.accept("./ProviderIntegrations.vue?vue&type=template&id=7b40d0b8&scoped=true&", function () {
      api.rerender('7b40d0b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/ProviderIntegrations.vue"
export default component.exports